import { FC } from "react";

import { ButtonVariantType } from "@/components/VnButton/variants";
import { VnButton } from "@/components/VnButton/VnButton";
import { VnLink } from "@/components/VnLink";
import { useApplicationFlowActions } from "@/hooks/useApplicationFlowActions";
import { I18nKeyType } from "@/i18n";

type ButtonVariantPropType = {
  variant?: ButtonVariantType;
  className?: string;
};

/** Starts a brand-new application (begin quick apply). */
export const StartApplicationButton: FC<
  ButtonVariantPropType & { i18nKey?: I18nKeyType }
> = ({
  variant,
  className,
  i18nKey = "native:applicationSection.quickApply",
}) => (
  <VnLink
    href={{ pathname: "/(authed)/(modal)/application/start" }}
    renderAsButton
    i18nKey={i18nKey}
    // VnLink forwards its own `className` onto the button (buttonProps.className
    // would be overwritten by it), so width overrides go here.
    className={className}
    buttonProps={{ variant }}
  />
);

/** Resumes the in-progress draft application. */
export const ContinueApplicationButton: FC<
  ButtonVariantPropType & { i18nKey?: I18nKeyType }
> = ({
  variant,
  className,
  i18nKey = "native:applicationSection.continueQuickApply",
}) => {
  const { handleContinueApplication, isContinuing } =
    useApplicationFlowActions();

  return (
    <VnButton
      variant={variant}
      className={className}
      isLoading={isContinuing}
      i18nKey={i18nKey}
      onPress={() => {
        void handleContinueApplication();
      }}
    />
  );
};

/** Discards the current draft(s) and starts a fresh application. */
export const NewQuickApplyButton: FC<ButtonVariantPropType> = ({
  variant = "secondary",
  className,
}) => {
  const { handleNewApplication, isDeletingDrafts } =
    useApplicationFlowActions();

  return (
    <VnButton
      variant={variant}
      className={className}
      isLoading={isDeletingDrafts}
      i18nKey="native:applicationSection.newQuickApply"
      onPress={() => {
        void handleNewApplication();
      }}
    />
  );
};
